module.exports = __webpack_public_path__ + "08670fd5cfc02c9d2ac3f37a38273fd6.svg";